import { ModalImportBcComponent } from './modals/modal-import-bc/modal-import-bc.component';
import { MatIconModule } from '@angular/material/icon';
import { ModalAddBcDocumentComponent } from './modals/modal-add-bc-document/modal-add-bc-document.component';
import { ModalShowBcDocumentComponent } from './modals/modal-show-bc-document/modal-show-bc-document.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MaterialModule } from 'src/app/material/material.module';
import { AuthGuard } from 'src/app/shared/services/auth.guard';
import { JwtHelper } from 'src/app/shared/services/jwtHelper';
import { SharedModule } from 'src/app/shared/shared.module';
import { AmountComponentService } from '../amount.component.service';
import { BcComponentsService } from './bc-components.service';
import { BcFormComponent } from './bc-form/bc-form.component';
import { BrouillonBcComponent } from './brouillon/brouillon-bc.component';
import { CreateBcComponent } from './create-bc/create-bc.component';
import { EditBcComponent } from './edit-bc/edit-bc.component';
import { ListeBcComponent } from './liste-bc/liste-bc.component';
import { PdfBcComponent } from './pdf-bc/pdf-bc.component';
import { ReadBcComponent } from './read-bc/read-bc.component';
import { BcListComponent } from './table/bc-list/bc-list.component';
import { EditBcLineListComponent } from './table/edit-bc-line-list/edit-bc-line-list.component';
import { FixedBcLineListReadComponent } from './table/fixed-bc-line-list-read/fixed-bc-line-list-read.component';
import { FixedBcLineListValidationComponent } from './table/fixed-bc-line-list-validation/fixed-bc-line-list-validation.component';
import { IncrementedBcLineListComponent } from './table/incremented-bc-line-list/incremented-bc-line-list.component';
import { ValidateBcComponent } from './validate-bc/validate-bc.component';
import { CyclesBcComponent } from './cycles-bc/cycles-bc.component';
import { InfoLettrageComponent } from './modals/info-lettrage/info-lettrage.component';
import { FixedLettrageBpArrayComponent } from './table/fixed-lettrage-bp-array/fixed-lettrage-bp-array.component';
import { ModalBcLineInfoComponent } from './modals/modal-bc-line-info/modal-bc-line-info.component';
import { FixedBcLineListEditComponent } from './table/fixed-bc-line-list-edit/fixed-bc-line-list-edit.component';
import { ModalGooglePickerComponent } from './modals/modal-google-picker/modal-google-picker.component';
import { ModalRechercheFournisseurComponent } from './modals/modal-recherche-fournisseur/modal-recherche-fournisseur.component';
import { FournisseurListComponent } from './table/fournisseur-list/fournisseur-list.component';
import { ModalCycleValidationComponent } from './modals/modal-cycle-validation/modal-cycle-validation.component';
import { CycleValidationListComponent } from './table/cycle-validation-list/cycle-validation-list.component';
import { ModalFormulaireEmailComponent } from './modals/modal-formulaire-email/modal-formulaire-email.component';
import { EditBcEnvLineListComponent } from './table/edit-bc-env-line-list/edit-bc-env-line-list.component';
import { ModalBcLineEnvInfoComponent } from './modals/modal-bc-env-line-info/modal-bc-env-line-info.component'; 
import { BcligneEnveloppeCreateFormComponent } from './bcligne-enveloppe/bcligne-enveloppe-create-form/bcligne-enveloppe-create-form.component';
import { BrouillonEnveloppeComponent } from './brouillon-enveloppe/brouillon-enveloppe.component';



@NgModule({
  declarations: [
    ListeBcComponent,
    CreateBcComponent,
    EditBcComponent,
    BrouillonBcComponent,
    ReadBcComponent,
    EditBcLineListComponent,
    ValidateBcComponent,
    PdfBcComponent,
    BcListComponent,
    BcFormComponent,
    ModalShowBcDocumentComponent,
    ModalAddBcDocumentComponent,
    EditBcLineListComponent,
    FixedBcLineListEditComponent,
    FixedBcLineListReadComponent,
    IncrementedBcLineListComponent,
    FixedBcLineListValidationComponent,
    ModalBcLineInfoComponent,
    CyclesBcComponent,
    InfoLettrageComponent,
    FixedLettrageBpArrayComponent,
    ModalImportBcComponent,
    ModalGooglePickerComponent,
    ModalRechercheFournisseurComponent,
    FournisseurListComponent,
    ModalCycleValidationComponent,
    CycleValidationListComponent,
    ModalFormulaireEmailComponent,
    EditBcEnvLineListComponent,
    ModalBcLineEnvInfoComponent,
    BcligneEnveloppeCreateFormComponent,
    BrouillonEnveloppeComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatCardModule,
    MatIconModule
  ],
  providers:  [
    BcComponentsService,
    AmountComponentService,
    AuthGuard,
    JwtHelper
  ],
  exports: [
    CyclesBcComponent,]
})
export class BcModule { }
